import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axiosInstance from "../api/axios"; // adjust import
// import Spinner from "../components/Spinner"; // if you have one

export default function TagFeed() {
  const { tagName } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const fetchTaggedPosts = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await axiosInstance.get(`/posts/?tag=${encodeURIComponent(tagName)}`);
        if (isMounted) {
          setPosts(res.data.results ?? res.data);
        }
      } catch (err) {
        console.error(err);
        if (isMounted) {
          const msg = err.response?.data?.detail || "Failed to load posts for this tag.";
          setError(msg);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchTaggedPosts();

    return () => {
      isMounted = false;
    };
  }, [tagName]);

  const handleOpenPost = (postId) => {
    navigate(`/posts/${postId}`, {
      state: { backgroundLocation: location },
    });
  };

  if (loading) {
    return (
      <div className="p-4">
        <div className="text-sm text-gray-500">Loading posts...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4">
        <div className="text-sm text-red-500">{error}</div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-5xl mx-auto px-4 py-6">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold">#{tagName}</h1>
        <p className="text-sm text-gray-500 mt-1">
          {posts.length} {posts.length === 1 ? "post" : "posts"}
        </p>
      </div>

      {posts.length === 0 ? (
        <div className="rounded-2xl border p-6 text-sm text-gray-500">
          No posts found for #{tagName}.
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-1 sm:gap-2 md:gap-3">
          {posts.map((post) => (
            <TagPostGridItem key={post.id} post={post} onClick={() => handleOpenPost(post.id)} />
          ))}
        </div>
      )}
    </div>
  );
}

function TagPostGridItem({ post, onClick }) {
  const mediaUrl = post.media_type === "image" ? post.media_url : null;
  const isVideo = post.media_type === "video";

  return (
    <button
      type="button"
      onClick={onClick}
      className="relative aspect-square w-full overflow-hidden bg-gray-100 text-left"
    >
      {mediaUrl ? (
        <img src={mediaUrl} alt={post.text || "img"} className="h-full w-full object-cover" />
      ) : isVideo ? (
        <div className="flex h-full w-full items-center justify-center bg-gray-200 text-sm text-gray-600">
          <video controls className="w-full h-[80vh] shadow flex items-center justify-center" muted>
            <source src={post.media_url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      ) : (
        <div className="flex h-full w-full items-start justify-start p-3 bg-gray-50">
          <p className="text-xs sm:text-sm text-gray-700 line-clamp-6">
            {post.text || "Text post"}
          </p>
        </div>
      )}

      <div className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-colors" />
    </button>
  );
}

//   export default TagPostGridItem;
